import useSurveyStatisticsSource from './useSurveyStatisticsSource';
import useYieldStatisticsSource from './useYieldStatisticsSource';
import { Dispatch } from 'react';
import type {
  FarmRef,
  FieldRef,
  LayerStatisticsSource,
  SeasonRef,
  SurveyClassificationValues,
  SurveyReferenceValues,
  YieldDataByField,
} from './LayerStatisticsSourceTypes';
import { ViewMode } from '../../../constants/ViewModeConstants';

type LayerStatisticsSourceParams = {
  layer: string | null;
  viewMode: ViewMode;
  classificationsEnabled: boolean;
  variationsEnabled: boolean;
  selectedSurveyReferenceValues: SurveyReferenceValues | null;
  selectedSurveyClassificationValues: SurveyClassificationValues;
  date: string | null;
  dispatch: Dispatch<any>;
  farm: FarmRef | null;
  selectedField: FieldRef | null;
  selectedSeason: SeasonRef | null;
  yieldData: YieldDataByField | null;
};

const emptySource: LayerStatisticsSource = {
  values: null,
  buckets: null,
  summaryData: null,
  classificationData: null,
  useClassificationBuckets: false,
  isReady: false,
  selectedField: null,
};

const useLayerStatisticsSource = ({
  layer,
  viewMode,
  classificationsEnabled,
  variationsEnabled,
  selectedSurveyReferenceValues,
  selectedSurveyClassificationValues,
  date,
  dispatch,
  farm,
  selectedField,
  selectedSeason,
  yieldData,
}: LayerStatisticsSourceParams): LayerStatisticsSource => {
  const surveySource = useSurveyStatisticsSource({
    layer,
    viewMode,
    classificationsEnabled,
    variationsEnabled,
    selectedSurveyReferenceValues,
    selectedSurveyClassificationValues,
    selectedField,
  });
  const yieldSource = useYieldStatisticsSource({
    layer,
    dispatch,
    date,
    farm,
    selectedField,
    selectedSeason,
    yieldData,
  });

  if (yieldSource.isReady) {
    return yieldSource;
  }

  if (surveySource.isReady) {
    return surveySource;
  }

  return emptySource;
};

export default useLayerStatisticsSource;
